import { render, staticRenderFns } from "./verPedido.vue?vue&type=template&id=5cc212ff&"
import script from "./verPedido.vue?vue&type=script&lang=js&"
export * from "./verPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports